import { FC } from 'react';
import { useAppSelector } from '../../../store/configureStore';

import { ConnectivityData } from '../../../utils/models';
import { getConnectivity } from '../../../store/connectivity';

import css from './connectivity.module.scss';

const Connectivity: FC = () => {
	const connectivity: ConnectivityData = useAppSelector(getConnectivity);

	const getIcon = (): string => {
		let defaultIcon = 'bi bi-';
		defaultIcon += connectivity.isConnected ? 'wifi' : 'wifi-off';

		return defaultIcon;
	};

	const getClassName = (): string => {
		return connectivity.isConnected ? css.connected : css.disconnected;
	};

	const getLabel = (): string => {
		return connectivity.isConnected ? "You're Online" : "You're Offline";
	};

	return (
		<div className={getClassName()}>
			<i className={getIcon()}></i>
			<span className={css.label}>{getLabel()}</span>
		</div>
	);
};

export default Connectivity;
